export const originalTypes = {
  delivery: {
    stopType: 2,
    stopTypeDescription: "D",
  },
  collection: {
    stopType: 5,
    stopTypeDescription: "C",
  },
  break: {
    stopType: 3,
    stopTypeDescription: "B",
  },
  pickup: {
    stopType: 4,
    stopTypeDescription: "P",
  },
  t: {
    stopType: 6,
    stopTypeDescription: "T",
  },
};

export default {
  delivery: "D",
  break: "B",
  collection: "C",
  shop: "P",
};
